/*
 * Kuuraii verified storefront funnel, 2026-10-20.
 * Separate event names deliberately avoid duplicating vendor ecommerce events.
 * Purchase remains the checkout provider's responsibility and must be joined to
 * Shopify order IDs before excluding draft/manual, test and cancelled orders.
 */
(function () {
  'use strict';
  if (window.__kuuraiiFunnelMeasurement) return;
  window.__kuuraiiFunnelMeasurement = '2026-10-20.1';
  var VERSION = '2026-10-20.1';
  var GA_ID = 'G-VE9MM3H3MN';
  var debug = new URLSearchParams(window.location.search).get('kuuraii_measurement_debug') === '1';
  var pending = [];
  var clarityPending = [];
  var diagnostics = [];
  var privacyRequested = false;
  var lastPermission;

  function report(message) {
    if (!debug) return;
    diagnostics.push(message);
    if (diagnostics.length > 12) diagnostics.shift();
    if (!document.body) return;
    var panel = document.getElementById('kuuraii-measurement-diagnostics');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'kuuraii-measurement-diagnostics';
      panel.setAttribute('aria-label', 'Measurement diagnostics');
      panel.setAttribute('data-clarity-mask', 'true');
      panel.style.cssText = 'position:fixed;bottom:8px;left:8px;z-index:2147483647;max-width:520px;max-height:230px;overflow:auto;background:#fff;color:#111;border:2px solid #165b3d;padding:10px;font:12px/1.4 monospace';
      var output = document.createElement('pre');
      output.id = 'kuuraii-measurement-output';
      panel.appendChild(output);
      var consent = document.createElement('button');
      consent.type = 'button';
      consent.textContent = 'Allow analytics for this QA visit';
      consent.addEventListener('click', function () {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
          report('Consent API not loaded; permission unchanged');
          return;
        }
        privacy.setTrackingConsent({ analytics: true }, function () {
          report('QA visitor chose analytics consent');
          flush();
        });
      });
      panel.appendChild(consent);
      document.body.appendChild(panel);
    }
    var output = document.getElementById('kuuraii-measurement-output');
    if (output) output.textContent = 'Kuuraii measurement QA · ' + VERSION + '\n' + diagnostics.join('\n');
  }

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return null;
    try { return privacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }

  function flushClarity() {
    if (allowed() !== true || typeof window.clarity !== 'function') return;
    while (clarityPending.length) {
      var event = clarityPending.shift();
      window.clarity('set', 'funnel_measurement_version', VERSION);
      if (debug) window.clarity('set', 'measurement_test', 'true');
      window.clarity('event', debug ? 'qa_' + event : event);
      report('Clarity queued: ' + (debug ? 'qa_' + event : event));
    }
  }

  function send(event, parameters) {
    parameters.send_to = GA_ID;
    parameters.measurement_version = VERSION;
    parameters.measurement_test = debug ? 'true' : 'false';
    if (debug) parameters.debug_mode = true;
    window.dataLayer = window.dataLayer || [];
    // Same Google tag already installed in the store; no new config/page_view.
    (function () { window.dataLayer.push(arguments); })(
      'event', debug ? 'qa_' + event : event, parameters
    );
    report('Google tag queued: ' + (debug ? 'qa_' + event : event));
    clarityPending.push(event);
    if (clarityPending.length > 30) clarityPending.shift();
    flushClarity();
  }

  function flush() {
    var permission = allowed();
    if (debug && lastPermission !== permission) {
      lastPermission = permission;
      report('Analytics processing allowed: ' + permission);
    }
    if (permission === false) {
      pending.length = 0;
      clarityPending.length = 0;
      return;
    }
    if (permission !== true) return;
    while (pending.length) {
      var item = pending.shift();
      if (Date.now() - item.at < 30000) send(item.event, item.parameters);
    }
    flushClarity();
  }

  function emit(event, parameters) {
    report('Confirmed: ' + event);
    var permission = allowed();
    if (permission === false) { report('Suppressed: analytics consent denied'); return; }
    if (permission === true) { send(event, parameters); return; }
    pending.push({ event: event, parameters: parameters, at: Date.now() });
    if (pending.length > 30) pending.shift();
    requestPrivacy();
  }

  function requestPrivacy() {
    if (allowed() !== null) { flush(); return; }
    if (privacyRequested || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      if (!error) flush();
      else report('Consent API load callback: ' + String(error.message || error));
    });
  }

  function isCartAdd(input, options) {
    try {
      var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      var method = (options && options.method) || (input && input.method) || 'GET';
      return url.origin === window.location.origin &&
        /(?:^|\/)cart\/add(?:\.js)?\/?$/.test(url.pathname) &&
        String(method).toUpperCase() === 'POST';
    } catch (_) { return false; }
  }

  function confirmedCart(payload) {
    if (!payload || payload.status || payload.errors) return;
    var lines = Array.isArray(payload.items) ? payload.items : [payload];
    var realLines = lines.filter(function (line) {
      return line && (line.variant_id || line.id) && Number(line.quantity) > 0 &&
        Number(line.original_price !== undefined ? line.original_price : line.price) > 0 &&
        !(line.properties && String(line.properties._kuuraii_reward_gift) === 'true') &&
        line.handle !== 'free-test-product';
    });
    if (!realLines.length) { report('Ignored: gift/test/empty cart addition'); return; }
    var bedding = realLines.some(function (line) {
      return /bedsheet|bedspread/i.test(String(line.product_type || '') + ' ' + String(line.handle || '') + ' ' + String(line.product_title || ''));
    });
    emit('kuuraii_cart_added', {
      event_source: 'shopify_ajax_success',
      product_group: bedding ? 'bedsheets_bedspreads' : 'other',
      line_count: realLines.length
    });
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var track = isCartAdd(args[0], args[1]);
      var promise = originalFetch.apply(this, args);
      if (track) promise.then(function (response) {
        if (!response.ok) { report('Ignored: rejected cart addition ' + response.status); return; }
        try { response.clone().json().then(confirmedCart).catch(function () {}); } catch (_) {}
      }, function () { report('Ignored: failed cart request'); });
      return promise;
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    var xhrRequests = new WeakMap();
    window.XMLHttpRequest.prototype.open = function (method, url) {
      xhrRequests.set(this, { method: method, url: url });
      return originalOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var request = xhrRequests.get(xhr);
      if (request && isCartAdd(request.url, { method: request.method })) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try {
            var payload = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText);
            confirmedCart(payload);
          } catch (_) {}
        }, { once: true });
      }
      return originalSend.apply(this, arguments);
    };
  }

  // Checkout opening is a loaded, visible checkout iframe, never its launch click.
  // No cross-origin checkout contents, customer inputs or payment data are read.
  var frames = new Map();
  var loadedFrames = new WeakSet();
  document.addEventListener('load', function (event) {
    var frame = event.target;
    if (frame && frame.tagName === 'IFRAME' && provider(frame)) {
      loadedFrames.add(frame);
      if (frames.has(frame)) frames.get(frame).loaded = true;
      inspectFrames();
    }
  }, true);
  function provider(frame) {
    try {
      var url = new URL(frame.src);
      if (frame.id === 'gokwik-iframe' && url.origin === 'https://pdp.gokwik.co' && url.pathname === '/index.html') return 'gokwik';
      if (url.origin === 'https://quick.paytring.com' && url.pathname.indexOf('/quick/kuuraii/') === 0) return 'paytring';
    } catch (_) {}
    return '';
  }
  function visible(frame) {
    if (!frame.isConnected) return false;
    var rect = frame.getBoundingClientRect();
    if (rect.width < 100 || rect.height < 100) return false;
    var element = frame;
    while (element && element.nodeType === 1) {
      var style = window.getComputedStyle(element);
      if (element.hidden || element.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      element = element.parentElement;
    }
    return true;
  }
  function inspectFrames() {
    document.querySelectorAll('iframe').forEach(function (frame) {
      var name = provider(frame);
      if (!name || frames.has(frame)) return;
      var state = { loaded: loadedFrames.has(frame), open: false, provider: name };
      frames.set(frame, state);
      frame.addEventListener('load', function () {
        state.loaded = true;
        inspectFrames();
      });
    });
    frames.forEach(function (state, frame) {
      if (!frame.isConnected) { frames.delete(frame); return; }
      var nowOpen = state.loaded && visible(frame) && provider(frame) === state.provider;
      if (nowOpen && !state.open) {
        emit('kuuraii_checkout_opened', {
          event_source: 'loaded_visible_checkout_frame',
          checkout_provider: state.provider
        });
      }
      state.open = nowOpen;
    });
  }
  function start() {
    report('Ready; QA events use qa_ prefix and are excluded from live funnel');
    requestPrivacy();
    inspectFrames();
    new MutationObserver(inspectFrames).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'src']
    });
  }
  document.addEventListener('visitorConsentCollected', flush);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  // Retry only the existing analytics queue, not cart requests or checkout actions.
  var attempts = 0;
  var timer = window.setInterval(function () {
    requestPrivacy();
    flush();
    if (++attempts >= 60) window.clearInterval(timer);
  }, 1000);
})();
